// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2_bt8","label":"Section_label__2fnYv","contentWrap":"Section_contentWrap__1lSKO","footer":"Section_footer__21pns","footerInner":"Section_footerInner__27mv8"};